import LanguagesListSection
    from 'views/Localization/components/LanguagesListSection/LanguagesListSection';
import ExportTranslationsCSVSection
    from 'views/Localization/components/TranslationsCSVSection//ExportTranslationsCSVSection';
import ImportTranslationsCSVSection
    from 'views/Localization/components/TranslationsCSVSection/ImportTranslationsCSVSection';

import PortalHeader from 'components/PortalHeader/PortalHeader';

const LocalizationView = () => {
    return (
        <div className="overflow-y-scroll overflow-x-hidden">
            <PortalHeader
                title="Translations"
            />
            <div className="mx-7 mb-9">
                <LanguagesListSection />
                <ExportTranslationsCSVSection />
                <ImportTranslationsCSVSection />
            </div>
        </div>
    )
}

export default LocalizationView;
